export default __webpack_public_path__ + "static/article-1d617af13f7c0a7b002f7bdb9c5b72c1.pdf";